import { render, staticRenderFns } from "./kczcContent.vue?vue&type=template&id=515d2148&scoped=true"
import script from "./kczcContent.vue?vue&type=script&lang=ts"
export * from "./kczcContent.vue?vue&type=script&lang=ts"
import style0 from "./kczcContent.vue?vue&type=style&index=0&id=515d2148&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d2148",
  null
  
)

export default component.exports